<template>
  <div class="department">
    <div class="row-one">
      <div>
        <el-button
          type="primary"
          size="small"
          class="addCount"
          @click="addDepartment"
        >
          新建
        </el-button>
        <el-button
          size="small"
          class="addCount"
          @click="importDepartment"
          v-if="false"
        >
          导入
        </el-button>
      </div>
      <!-- <Search
        placeholder="支持搜索部门"
        @handleSearch="getDepartments"
      ></Search> -->
    </div>
    <el-table
      :data="tableData"
      tooltip-effect="light"
      style="width: 100%"
      row-key="id"
      default-expand-all
      :tree-props="treeProps"
    >
      <el-table-column
        label="组织架构"
        prop="name"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="200px"
        align="center"
        class-name="options td-pt1"
      >
        <template slot-scope="scope">
          <span class="textBtn" @click="handleDetail(scope.row)">
            详情
          </span>
          <span
            class="textBtn delete"
            @click="handleDelete(scope.row.id)"
            v-if="scope.row.path && scope.row.path.split('/').length > 2"
          >
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :close-on-click-modal="false"
      title="新建部门"
      width="600px"
      :visible.sync="dialogAddVisible"
    >
      <el-form
        :model="formDepartment"
        :rules="ruleformDepartment"
        ref="formDepartment"
        label-width="100px"
      >
        <el-form-item label="部门名称" prop="name">
          <el-input
            v-model="formDepartment.name"
            :maxlength="32"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="父级部门" prop="superName">
          <el-select
            ref="departSelect"
            class="departSelect"
            popper-class="departSelect"
            @visible-change="visibleChange"
            v-model="formDepartment.superName"
            placeholder="请选择父级部门，支持搜索查找"
            filterable
            :filter-method="filterMethod"
          >
            <el-option :value="selectOption.value" :label="selectOption.label">
              <el-tree
                ref="departTree"
                :data="tableData"
                node-key="id"
                :highlight-current="true"
                :expand-on-click-node="false"
                :check-on-click-node="true"
                :default-expand-all="true"
                :check-strictly="true"
                :props="defaultProps"
                :filter-node-method="filterNode"
                @node-click="handleNodeClick"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddForm">确 定</el-button>
        <el-button @click="dialogAddVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="tipTitle"
      width="500px"
      :visible.sync="dialogDeleteDepart"
    >
      <div class="deleteText">
        {{ tipText }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDeleteDepart">确 定</el-button>
        <el-button @click="dialogDeleteDepart = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/department.js"
// import Search from "@/components/common/Search.vue"
import { flatten } from "@/common/utils.js"
export default {
  components: {
    // Search
  },
  data() {
    return {
      selectOption: {
        value: "",
        label: ""
      },
      tipTitle: "删除部门",
      tipText: "确认要删除该部门吗？",
      dialogDeleteDepart: false,
      breadcrumb: [
        {
          label: "部门管理"
        }
      ],
      realmName: this.$realm,
      formDepartment: {
        name: "",
        superName: ""
      },
      ruleformDepartment: {
        name: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        superName: [
          { required: true, message: "请输入父级部门", trigger: "blur" }
        ]
      },
      tableData: [],
      dialogAddVisible: false,
      cascaderProps: {
        checkStrictly: true,
        value: "id",
        label: "name",
        children: "subGroups",
        emitPath: false
      },
      treeProps: {
        label: "name",
        children: "subGroups"
      },
      currentDepartId: "",
      rootDepartId: "",
      defaultProps: {
        children: "subGroups",
        label: "name"
      }
    }
  },
  mounted() {
    this.getDepartments()
  },
  methods: {
    // 获取部门列表
    async getDepartments(keywords) {
      let params = {
        key: keywords || ""
      }
      let { status, data } = await APIS.getDepartments(this.realmName, {
        params
      })
      this.tableData = []
      if (status === 0) {
        this.tableData = this.formatSubgroups(data)
        this.formDepartment.superName = this.rootDepartId =
          data[0] && data[0].id
        // 设置select默认选择的部门
        this.selectOption.value = data[0] && data[0].id
        this.selectOption.id = data[0] && data[0].id
        this.selectOption.label = data[0] && data[0].name
      }
    },
    // 新建部门
    async postDepartments() {
      let params = {
        parentId: this.formDepartment.superName,
        name: this.formDepartment.name
      }
      let { status } = await APIS.postDepartments(this.realmName, {
        data: params
      })
      if (status === 0) {
        this.dialogAddVisible = false
        this.getDepartments()
      }
    },
    // 确认删除部门
    async submitDeleteDepart() {
      let { status } = await APIS.deleteDepartment(
        this.realmName,
        this.currentDepartId
      )
      this.dialogDeleteDepart = false
      if (status === 0) {
        this.getDepartments()
      }
    },
    // 部门过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 选择框搜索，触发tree搜索
    filterMethod(value) {
      this.$refs.departTree.filter(value)
    },
    // // 部门树复选框被点击触发
    // handleCheckChange(currentNode) {
    //   // 设置option选择的部门
    //   this.selectOption.id = currentNode.id
    //   this.selectOption.value = currentNode.id
    //   this.selectOption.label = currentNode.name
    //   // 设置select选择的部门
    //   this.formDepartment.superName = currentNode.id
    //   // 设置tree选择的部门
    //   this.$refs.departTree.setCheckedNodes([currentNode])
    // },
    // 树节点被点击了
    handleNodeClick(currentNode) {
      // 设置option选择的部门
      this.selectOption.id = currentNode.id
      this.selectOption.value = currentNode.id
      this.selectOption.label = currentNode.name
      // 设置select选择的部门
      this.formDepartment.superName = currentNode.id
      // 设置tree选择的部门
      this.$refs.departTree.setCheckedNodes([currentNode])
      // 使 input 失去焦点，并隐藏下拉框
      this.$refs.departSelect.blur()
    },
    // 下拉框展示
    visibleChange(value) {
      if (value) {
        // 初始化tree搜索状态
        this.$refs.departTree.filter("")
        // 初始化tree选择的部门
        this.$refs.departTree.setCheckedNodes([this.selectOption])
        // 初始化tree选择的部门
        this.$refs.departTree.setCurrentNode(this.selectOption)
      }
    },
    // 初始化表单
    initForm() {
      this.formDepartment.name = ""
      this.formDepartment.superName = this.rootDepartId
      this.selectOption.value = this.tableData[0] && this.tableData[0].id
      this.selectOption.id = this.tableData[0] && this.tableData[0].id
      this.selectOption.label = this.tableData[0] && this.tableData[0].name
      this.$refs.formDepartment.resetFields()
    },
    // 打开新建部门弹窗
    addDepartment() {
      this.dialogAddVisible = true
      this.$nextTick(() => {
        this.initForm()
      })
    },
    // 如果subgroups为空数组，则删掉改字段
    formatSubgroups(data) {
      data.forEach(item => {
        if (item.subGroups && item.subGroups.length !== 0) {
          this.formatSubgroups(item.subGroups)
        } else {
          delete item.subGroups
        }
      })
      return data
    },
    importDepartment() {},
    // 去部门详情页
    handleDetail({ id, path, name }) {
      // 获取父级部门ID方法：
      // 1、通过当前部门path，获取父级部门的path
      // 2、通过父级部门path，获取父级部门id
      let superPath = path === `/${name}` ? path : path.replace(new RegExp("/" + `${name}` + "$"), "")
      // 获取扁平化后的数组
      let flatetenArr = flatten(this.tableData, "subGroups")
      let superId = flatetenArr.find(item => item.path === superPath).id
      this.$router.push({
        path: "/department/detail",
        query: {
          departId: id,
          superId: superId
        }
      })
    },
    // 打开删除部门弹窗
    handleDelete(id) {
      this.currentDepartId = id
      this.dialogDeleteDepart = true
    },
    submitAddForm() {
      this.$refs["formDepartment"].validate(valid => {
        if (valid) {
          if (this.formDepartment.superName) {
            this.postDepartments()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.department {
  .row-one {
    margin: 0 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-select-dropdown{
    z-index: 20240;
  }
  .el-dialog {
    .el-select.departSelect {
      width: 100%;
    }
    &__title {
      color: #333333;
      font-weight: 600;
    }
    .deleteText {
      text-align: center;
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>
